export const toPascalCase = (str) => {
  if(!str) return str
  return str
    .toLowerCase()
    .replace(/(?:^|\s|_|-|\b)(\w)/g, (match, p1) => p1.toUpperCase())
    .replace(/[\s_-]/g, '');
};